import { module } from 'angular';

import { ChatbotService, default as chatbotServiceName } from './chatbot.service';

export default module('contact.agent.core.channel-digit.chatbot', [])
  .run([chatbotServiceName, () => {}])
  .service(chatbotServiceName, ChatbotService).name;
